export const VIEW_TYPES = {
  resources: "resources",
  tasks: "tasks",
  clients: "clients",
  planView: "plan",
  schedulerView: "scheduler",
  notify: "notify",
  reminder: "reminders",
  taskBudget: 'tasks-budget',
  users: 'users',
  checklists: 'checklists',
  contacts: 'contacts',
  mySwivu: "my-swivu",
  incentivePoints: "incentive-points",
  clocking: "clocking",
  entityManager: "entity-manager",
  settings: "settings",
  coverage: "coverage",
  promote: "promote",
  workFiles: "work-files",
  marketingPages: "marketing-pages",
  site: "site",
  leads: "leads",
  context: "context",
  marketingManifest: "marketing-manifest",
}

export const IMPORT_TYPES_HISTORY = {
  tasks: 1,
  resources: 2,
  clients: 3,
  contacts: 4,
  "tasks-budget": 5,
  "board-users": 6
}

/* Swivu Assist config Map
- Provided to editor tabs as swivuAssistance config property in configurable
- Mapped to view types to show content by column ids of excel sheet
*/
export const SWIVU_ASSIST_CONFIG = {
  task: {
    type: "tasks",
    popupTitle: "Task Manager Help"
  },
  resource: {
    type: "resources",
    popupTitle: "Resource Manager Help"
  },
  client: {
    type: "clients",
    popupTitle: "Client Manager Help"
  },
  contact: {
    type: "contacts",
    popupTitle: "Contact Manager Help"
  },
  checklist: {
    type: "checklists",
    popupTitle: "Checklist Manager Help"
  },
  notify: {
    type: "notify",
    popupTitle: "Notify Manager Help"
  },
  reminder: {
    type: "reminders",
    popupTitle: "Reminder Manager Help"
  },
  user: {
    type: "users",
    popupTitle: "User Manager Help"
  },
  budget: {
    type: "budget",
    popupTitle: "Budget Manager Help"
  },
  files: {
    type: "files",
    popupTitle: "File Manager Help"
  },
  notes: {
    type: "notes",
    popupTitle: "Note Manager Help"
  },
  planning: {
    type: "planning",
    popupTitle: "Planning Manager Help"
  },
  status: {
    type: "status",
    popupTitle: "Status Manager Help"
  },
  history: {
    type: "history",
    popupTitle: "History Manager Help"
  },
  dashboard: {
    type: "dashboard",
    popupTitle: "Dashboard Manager Help"
  },
  scheduler: {
    type: "scheduler",
    popupTitle: "Scheduler Manager Help"
  },
  plan: {
    type: "plan",
    popupTitle: "Plan Manager Help"
  },
  incentivePoints: {
    type: "incentive-points",
    popupTitle: "Points Manager Help"
  },
  ownership: {
    type: "ownership",
    popupTitle: "Ownership"
  },
  outcomeIncentive: {
    type: "outcome-incentive",
    popupTitle: "Outcome Points Manager Help"
  },
  spotIncentive: {
    type: "spot-incentive",
    popupTitle: "Spot Points Manager Help"
  }
}

/* Connect Swivu Assist Excel Sheet column id's to Swivu Assist Config */
export const SWIVU_ASSIST_COLUMN_MAP = {
  "99877": SWIVU_ASSIST_CONFIG.task.type,
  "99878": SWIVU_ASSIST_CONFIG.checklist.type,
  "99879": SWIVU_ASSIST_CONFIG.resource.type,
  "99880": SWIVU_ASSIST_CONFIG.client.type,
  "99881": SWIVU_ASSIST_CONFIG.reminder.type,
  "99882": SWIVU_ASSIST_CONFIG.budget.type,
  "99883": SWIVU_ASSIST_CONFIG.plan.type,
  "99884": SWIVU_ASSIST_CONFIG.contact.type,
  "99885": SWIVU_ASSIST_CONFIG.notify.type,
  "99886": SWIVU_ASSIST_CONFIG.user.type,
  "99887": SWIVU_ASSIST_CONFIG.files.type,
  "99888": SWIVU_ASSIST_CONFIG.notes.type,
  "99889": SWIVU_ASSIST_CONFIG.planning.type,
  "99890": SWIVU_ASSIST_CONFIG.status.type,
  "99891": SWIVU_ASSIST_CONFIG.history.type,
  "99892": SWIVU_ASSIST_CONFIG.dashboard.type,
  "99893": SWIVU_ASSIST_CONFIG.notes.type,
  "99894": SWIVU_ASSIST_CONFIG.files.type,
  "99895": SWIVU_ASSIST_CONFIG.scheduler.type,
  "99896": SWIVU_ASSIST_CONFIG.incentivePoints.type,
  "99897": SWIVU_ASSIST_CONFIG.ownership.type,
  "99898": SWIVU_ASSIST_CONFIG.outcomeIncentive.type,
  "99899": SWIVU_ASSIST_CONFIG.spotIncentive.type,
}

export const ViewFolderTypes = {
  coordination: 1,
  communication: 2,
  tracking: 3,
  more: 4,
  marketing: 5
};

/* Map view types to swivu assist config to show swivu assist content for respective view types */
export const SWIVU_ASSIST_VIEW_TYPE_MAP = {
  [VIEW_TYPES.resources]: SWIVU_ASSIST_CONFIG.resource,
  [VIEW_TYPES.tasks]: SWIVU_ASSIST_CONFIG.task,
  [VIEW_TYPES.clients]: SWIVU_ASSIST_CONFIG.client,
  [VIEW_TYPES.planView]: SWIVU_ASSIST_CONFIG.plan,
  [VIEW_TYPES.schedulerView]: SWIVU_ASSIST_CONFIG.scheduler,
  [VIEW_TYPES.notify]: SWIVU_ASSIST_CONFIG.notify,
  [VIEW_TYPES.reminder]: SWIVU_ASSIST_CONFIG.reminder,
  [VIEW_TYPES.taskBudget]: SWIVU_ASSIST_CONFIG.budget,
  [VIEW_TYPES.users]: SWIVU_ASSIST_CONFIG.user,
  [VIEW_TYPES.checklists]: SWIVU_ASSIST_CONFIG.checklist,
  [VIEW_TYPES.contacts]: SWIVU_ASSIST_CONFIG.contact,
  [VIEW_TYPES.incentivePoints]: SWIVU_ASSIST_CONFIG.incentivePoints,
}

export const DEFAULT_VIEW_COLOR = null;
export const VIEW_DEF_PREF = {
  [VIEW_TYPES.schedulerView]: {
    name: "Schedule",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.coordination,
    viewDescription: "Dates & Times"
  },
  [VIEW_TYPES.tasks]: {
    name: "Tasks",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.coordination,
    viewDescription: "Projects & Jobs"
  },
  [VIEW_TYPES.resources]: {
    name: "Resources",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.coordination,
    viewDescription: "Labor & Assets"
  },
  [VIEW_TYPES.clients]: {
    name: "Clients",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.coordination,
    viewDescription: "Customers & Accounts"
  },
  [VIEW_TYPES.users]: {
    name: "Users",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.coordination,
    viewDescription: "Roles & Permissions"
  },
  [VIEW_TYPES.contacts]: {
    name: "Contacts",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.communication,
    viewDescription: "Phone, Email, Address"
  },
  [VIEW_TYPES.notify]: {
    name: "Notify",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.communication,
    viewDescription: "Notification Dashboard"
  },
  [VIEW_TYPES.reminder]: {
    name: "Reminders",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.communication,
    viewDescription: "Pending & Sent"
  },
  [VIEW_TYPES.planView]: {
    name: "Plan",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.tracking,
    viewDescription: "Task Gantts"
  },
  [VIEW_TYPES.taskBudget]: {
    name: "Budget",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.tracking,
    viewDescription: "Estimates & Actuals"
  },
  [VIEW_TYPES.checklists]: {
    name: "Checklists",
    color: DEFAULT_VIEW_COLOR,
    iconId: null,
    folderType: ViewFolderTypes.tracking,
    viewDescription: "Assigned & Status"
  },
  [VIEW_TYPES.incentivePoints]: {
    name: "Points",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.tracking,
    iconId: null,
  },
  [VIEW_TYPES.clocking]: {
    name: "Clock",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.tracking,
    iconId: null,
    viewDescription: "Clock in / out review"
  },
  [VIEW_TYPES.context]: {
    name: "Context",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Your organization’s context for this board"
  },
  [VIEW_TYPES.marketingManifest]: {
    name: "Marketing Manifest",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Tags, hubs, hub mapping, SEO, and more — read-only, inherited from Context"
  },
  [VIEW_TYPES.coverage]: {
    name: "Coverage",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Marketing Readiness"
  },
  [VIEW_TYPES.workFiles]: {
    name: "Work Files",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Marketing Briefs"
  },
  [VIEW_TYPES.marketingPages]: {
    name: "Pages",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Published marketing pages"
  },
  [VIEW_TYPES.site]: {
    name: "Site",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Publish and manage your marketing site"
  },
  [VIEW_TYPES.leads]: {
    name: "Leads",
    color: DEFAULT_VIEW_COLOR,
    folderType: ViewFolderTypes.marketing,
    iconId: null,
    viewDescription: "Site intake submissions"
  },
}

export const IMPORT_TYPES = {
  tasks: VIEW_TYPES.tasks,
  resources: VIEW_TYPES.resources,
  clients: VIEW_TYPES.clients,
  taskBudget: VIEW_TYPES.taskBudget,
  contacts: VIEW_TYPES.contacts,
  boardUsers: "board-users",
}

export const IMPORT_HEADERS = {
  tasks: "Tasks",
  resources: "Resources",
  clients: "Clients",
  taskBudget: "Task Budget",
  contacts: "Contacts",
  boardUsers: "Board Users",
}

export const POPUP_IDS = {
  manageView: 0,
  createBoard: 1,
  demoMessagePopup: 2,
}

export const DynamicParamKey = "main";

export const AdminViewRoutes = {
  [VIEW_TYPES.schedulerView]: `/:${DynamicParamKey}/scheduler`,
  [VIEW_TYPES.planView]: `/:${DynamicParamKey}/plan`,
  [VIEW_TYPES.resources]: `/:${DynamicParamKey}/resources`,
  [VIEW_TYPES.tasks]: `/:${DynamicParamKey}/tasks`,
  [VIEW_TYPES.clients]: `/:${DynamicParamKey}/clients`,
  [VIEW_TYPES.notify]: `/:${DynamicParamKey}/notify`,
  [VIEW_TYPES.users]: `/:${DynamicParamKey}/users`,
  [VIEW_TYPES.checklists]: `/:${DynamicParamKey}/checklists`,
  [VIEW_TYPES.contacts]: `/:${DynamicParamKey}/contacts`,
  [VIEW_TYPES.taskBudget]: `/:${DynamicParamKey}/budget`,
  [VIEW_TYPES.reminder]: `/:${DynamicParamKey}/reminders`,
  [VIEW_TYPES.mySwivu]: `/:${DynamicParamKey}/my-swivu`,
  [VIEW_TYPES.incentivePoints]: `/:${DynamicParamKey}/points`,
  [VIEW_TYPES.clocking]: `/:${DynamicParamKey}/clocking`,
  [VIEW_TYPES.settings]: `/:${DynamicParamKey}/settings`,
  [VIEW_TYPES.coverage]: `/:${DynamicParamKey}/coverage`,
  [VIEW_TYPES.promote]: `/:${DynamicParamKey}/promote`,
  [VIEW_TYPES.workFiles]: `/:${DynamicParamKey}/work-files`,
  [VIEW_TYPES.marketingPages]: `/:${DynamicParamKey}/marketing-pages`,
  [VIEW_TYPES.site]: `/:${DynamicParamKey}/site`,
  [VIEW_TYPES.leads]: `/:${DynamicParamKey}/leads`,
  [VIEW_TYPES.context]: `/:${DynamicParamKey}/context`,
  [VIEW_TYPES.marketingManifest]: `/:${DynamicParamKey}/marketing-manifest`,
}

export const DEFAULT_VIEW_STATE = VIEW_TYPES.schedulerView;
export const DEFAULT_ROUTE = AdminViewRoutes[DEFAULT_VIEW_STATE];

export const TriggerKeyForStyleColor = "swivuTaskStyleColor";
export const TriggerKeyForLastUpdatedAt = "swivuUpdateBoardLastUpdateAt";

export const ReminderTypes = {
  task: 3,
  resource: 1,
  client: 2,
  boardAlert: 4,
  others: 5, // anything else such as incentive or exported
}


export const ResourceFieldKey = "resource";

export const RESOURCE_LABEL_MAX_LENGTH = 12;

export const TASK_BUDGET_PROPERTIES = {
  contractAmount: "contractAmount",
  changeOrders: "changeOrders",
  totalContract: "totalContract",
  totalCostEstimated: "totalCostEstimated",
  totalCostActual: "totalCostActual",
  totalCostVariance: "totalCostVariance",
  grossProfitEstimated: "grossProfitEstimated",
  grossProfitActual: "grossProfitActual",
  grossProfitVariance: "grossProfitVariance",
  grossMarginEstimated: "grossMarginEstimated",
  grossMarginActual: "grossMarginActual",
  grossMarginVariance: "grossMarginVariance",
  laborEstimated: "laborEstimated",
  laborActual: "laborActual",
  laborVariance: "laborVariance",
  materialsEstimated: "materialsEstimated",
  materialsActual: "materialsActual",
  materialsVariance: "materialsVariance",
  subsEstimated: "subsEstimated",
  subsActual: "subsActual",
  subsVariance: "subsVariance",
  rentalsEstimated: "rentalsEstimated",
  rentalsActual: "rentalsActual",
  rentalsVariance: "rentalsVariance",
  miscellaneousEstimated: "miscellaneousEstimated",
  miscellaneousActual: "miscellaneousActual",
  miscellaneousVariance: "miscellaneousVariance",
  daysEstimated: "daysEstimated",
  daysActual: "daysActual",
  daysVariance: "daysVariance",
  updatedFields: "updatedFields",
}

export const TASK_BUDGET_FIELDS = {
  title: "title",
  description: "description",
  ...TASK_BUDGET_PROPERTIES,
  // following is not part of data, but a getter in model
  budgetTitleDisplayValue: "budgetTitleDisplayValue",
  updatedAt: "updatedAt",
  createdAt: "createdAt"
}

export const NOTIFICATION_STATUS = {
  SENT: "Sent",
  FAILED: "Failed"
}

export const GRID_FIELDS_TO_OPEN_EDITOR = {
  ENTITY_NAME: "entityName",
  RECIPIENT_NAME: "recipients",
};

export const EDIT_MESSAGES = {
  category: "Edit Categories",
  status: "Edit Statuses",
  tag: "Edit Tags",
  team: "Edit Teams",
  phase: "Edit Phase",
  icon: "Edit Icons",
  type: "Edit Types",
  user: "Edit Users",
  viewFolder: "Manage View Folders",
}

// Note: the following values for each key being used in sorting reminder grid, so if sort desc then failed recs will come first and then not_seen and so on
export const REMINDER_STATE = {
  NO_REMINDER: 1,
  NOT_SENT: 2,
  NOT_SEEN: 4,
  SEEN: 3,
  FAILED: 5,
}

export const ALERT_TYPES = {
  REMINDER: 1,
  Nudge: 3,
  Checklist: 4,
  Weather: 5,
  EntityStatus: 6,
  NOTE: 7,
  Schedule: 8,
  GENERAL: 9,
  URGENT: 10,
  BoardAlert: 11,
  AsyncTask: 12,
  FILE: 13,
  LEADS: 14,
}

export const ALERT_TYPE_NAMES = {
  [ALERT_TYPES.REMINDER]: "Reminder",
  [ALERT_TYPES.Nudge]: "Nudge",
  [ALERT_TYPES.Checklist]: "Checklist",
  [ALERT_TYPES.Schedule]: "Schedule Change",
  [ALERT_TYPES.Weather]: "Weather",
  [ALERT_TYPES.EntityStatus]: "Status",
  [ALERT_TYPES.GENERAL]: "General",
  [ALERT_TYPES.NOTE]: "Note",
  [ALERT_TYPES.URGENT]: "Urgent",
  [ALERT_TYPES.BoardAlert]: "Board Alert",
  [ALERT_TYPES.FILE]: "File",
  [ALERT_TYPES.LEADS]: "Leads",
}

export const NOTIFY_PREFS_TYPES_TEXT = {
  [ALERT_TYPES.REMINDER]: "Reminders",
  [ALERT_TYPES.Schedule]: "Schedule Updates",
  [ALERT_TYPES.Checklist]: "Checklist Updates",
  [ALERT_TYPES.Nudge]: "Checklist Nudges",
  [ALERT_TYPES.EntityStatus]: "Status Updates",
  [ALERT_TYPES.GENERAL]: "General Updates",
  [ALERT_TYPES.NOTE]: "Notes Updates",
  [ALERT_TYPES.BoardAlert]: "Board Alerts",
  [ALERT_TYPES.FILE]: "Files Updates",
  [ALERT_TYPES.LEADS]: "Leads",
}

export const CHECKLIST_ITEM_STATUS_TYPE = {
  UNCHECKED: 1,
  CHECKED: 2
}

export const NOTIFICATION_BANNER_PREF_CODE = {
  None: 0,
  MyBannersOnly: 1,
  AllBanners: 2,
}

export const NOTIFICATIONS_BANNERS_PREF_NAMES = [
  { id: NOTIFICATION_BANNER_PREF_CODE.None, name: "None" },
  { id: NOTIFICATION_BANNER_PREF_CODE.MyBannersOnly, name: "My Banners Only" },
  { id: NOTIFICATION_BANNER_PREF_CODE.AllBanners, name: "All Banners" },
]

export const CHECKLIST_STATE = {
  NO_CHECKLIST: 0,
  IN_COMPLETE: 1,
  ALL_CHECKED: 2,
}

export const ViewType = {
  compact: "Compact",
  normal: "Normal",
  compressed: "Compressed",
}

export const SWIVU_HOME_VIEW = {
  auth: 1,
  welcome: 2,
  sandbox: 5,
  boardAlerts: 6,
  incentiveExecution: 7,
}

// this may have a relevant css class defined as well, make sure to check before updating this value
export const SWIVU_GROUP_CONTEXT_MENU_SELECTOR = ".swivu-show-context-menu";

export const BACKEND_NOTIFICATION_KEYS = {
  [ALERT_TYPES.REMINDER]: "reminder",
  [ALERT_TYPES.Schedule]: "schedule_change",
  [ALERT_TYPES.Checklist]: "checklist",
  [ALERT_TYPES.Nudge]: "checklist_nudge",
  [ALERT_TYPES.EntityStatus]: "status_change",
  [ALERT_TYPES.GENERAL]: "general",
  [ALERT_TYPES.NOTE]: "note",
  [ALERT_TYPES.FILE]: "file",
  [ALERT_TYPES.LEADS]: "leads",
}

export const REMINDER_ICONS = {
  NO_REMINDER: "fa-regular fa-bell",
  NOT_SENT: "fa-regular fa-bell",
  NOT_SEEN: "fa-regular fa-bell",
}

export const NO_VALUE = "!!novalue!!";

export const SOCKET_MESSAGE_TYPES = {
  PING: "ping",
  PONG: "pong",
  REVISION: "revision",
  SYNC: "sync",
  // To broadcast user's activity to other users
  ACTIVITY: "board_activity"
}

export const TIMELINE_CONG_KEYS = {
  nonWorkingTimeChecks: "nonWorkingTimeChecks",
  stripeNonWorkingDays: "stripeNonWorkingDays",
  hideNonWorkingDays: "hideNonWorkingDays",
  skipNonWorkingDayDuringReplicating: "skipNonWorkingDayDuringReplicating",
}

export const RESOURCE_FONT_SIZE = {
  Small: "",
  Medium: "fa-lg",
  Large: "fa-xl"
}

export const APP_HEADER_ID = "app-header-element";

export const APP_HEADER_HOVER_MENU_BUTTON_CLS = "swivu-header-hover-menu-button";

export const SWIVU_TOOLTIP_TRIGGER_CLS = "swivu-task-tooltip-trigger";

export const ICON_COL_DEF_WIDTH = 35;

export const SOCKET_CHANGES_UPDATE_NOTIFICATION = "swivuWebSocketChangesUpdate";

export const nonSupportedViewsForViewState = [
  VIEW_TYPES.notify,
  VIEW_TYPES.mySwivu,
  VIEW_TYPES.context,
  VIEW_TYPES.marketingManifest,
  VIEW_TYPES.site,
];

export const VIEW_STATE_PIITS_UPDATE_LISTENER = "swivuViewStatePIITSupdate";

export const SwivuDocumentType = {
  swivuFile: 2,
  ccDocument: 3,
}

export const ASYNC_TASK_STATUS = {
  PENDING: "Pending",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  FAILED: "Failed"
};

export const ASYNC_TASK_TYPES = {
  BOARD_DUPLICATION: 1,
  CSV_IMPORT: 2,
  CSV_EXPORT: 3,
  UNDO_CSV_IMPORT: 4,
  DEMO_BOARD_CREATION: 5,
  BOARD_IMPORT: 6,
  BOARD_EXPORT: 7,
  INCENTIVE_EVALUATION: 8,
  BULK_ENTITY_COPY: 9,
  MARKETING_MANIFEST_GENERATION: 10,
  MARKETING_TAGS_GENERATION: 11,
  MARKETING_WORK_FILE_GENERATION: 12,
  /** Must match backend async task enum for POST .../page/generate. */
  MARKETING_PAGE_GENERATION: 13,
  BOARD_CONTEXT_QUESTIONS_GENERATION: 14,
  BOARD_CONTEXT_GENERATION: 15,
  BOARD_CONTEXT_SUGGESTION: 16,
  /** Must match backend async task enum for POST .../sites/board/.../publish. */
  SITE_PUBLISH: 17,
  /** Must match backend async task enum for POST .../sites/board/.../publish-with-domain (or legacy domain/deploy). */
  SITE_CUSTOM_DOMAIN_DEPLOY: 18,
  /** Must match backend async task enum for POST .../document/generate. */
  MARKETING_DOCUMENT_GENERATION: 19,
};

export const REACT_EDITOR_CONTEXT_MENU_KEYS = {
  ARCHIVE: "archive",
  UNARCHIVE: "unarchive",
  DELETE: "delete",
  SWIVU_ASSIST: "swivu-assist"
}

export const SUPPORTED_VIEWS_FOR_EXPORT = [
  VIEW_TYPES.resources,
  VIEW_TYPES.tasks,
  VIEW_TYPES.clients,
  VIEW_TYPES.contacts,
  VIEW_TYPES.incentivePoints,
]

export const ENTITY_TYPES = {
  TASK: "task",
  RESOURCE: "resource",
  CLIENT: "client",
  CONTACT: "contact",
  USER: "user",
};

export const ALERT_ENTITIES = {
  [ReminderTypes.task]: {
    entityManagerPage: ENTITY_TYPES.TASK,
  },
  [ReminderTypes.resource]: {
    entityManagerPage: ENTITY_TYPES.RESOURCE,
  },
  [ReminderTypes.client]: {
    entityManagerPage: ENTITY_TYPES.CLIENT,
  },
};
